import styles from '@components/WysiwygSeoBlock/WysiwygSeoBlock.styles';
import sanitizeHtml from '@utils/sanitizeHtml';
import { SANITIZE_HTML_CONFIG } from '@const/index';
type PropsType = {
  description: string;
};
const WysiwygSeoBlock = ({
  description
}: PropsType) => {
  const processedDescription = description.replace(/<h1/g, '<h2').replace(/<\/h1/g, '</h2');
  return <section id="seoWysiwyg" sx={styles.section}>
      <div sx={styles.container}>
        <div sx={styles.contentContainer} dangerouslySetInnerHTML={sanitizeHtml(processedDescription, SANITIZE_HTML_CONFIG)} />
      </div>
    </section>;
};
export default WysiwygSeoBlock;